/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 21:20:49
 * @LastEditTime: 2020-08-11 11:45:13
 * @Description: 工厂api
 */
import axios from '@/utils/axios'

export const getFactorys = (payload) => {
    return axios.get('/factory', {
        params: payload
    })
}

export const createFactory = (data) => {
    return axios.post('/factory', data)
}

export const updateFactory = (id, data) => {
    return axios.put(`/factory/${id}`, data)
}